import { useBrandingStore } from '../context/brandingStore';

/**
 * useBranding — the tenant's brand, for any component that names the portal.
 *
 * Resolved once before the app renders (main.jsx), so this never suspends
 * and never flickers: by the time a component asks, the answer is in the
 * store, or the neutral defaults are, if the resolve call failed.
 *
 *   const { portalName, companyLogoUrl, poweredBy } = useBranding();
 */
export function useBranding() {
  return useBrandingStore((s) => s.branding);
}

export default useBranding;
